<template>
    <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="primary"
    dark
    flat
    >
        <v-btn icon to="/tasks">
          <v-icon>mdi-apps</v-icon>
        </v-btn>
        <v-btn icon @click="hasHistory() ? $router.go(-1) : $router.push('/')" v-if="back">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-img
            class="top-logo"
            max-width="100"
            :src="logo"
            alt="ASE"
        ></v-img>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              icon 
              to="/profile"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account-cog</v-icon>
            </v-btn>
          </template>
          <span>Profile Settings</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              icon 
              @click.prevent="signOut"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>Sign Out</span>
        </v-tooltip>
    </v-app-bar>
</template>

<script>
import { mapActions } from 'vuex'
import logo from "@/assets/logo.jpg"

export default {
    data: () => ({
        back: false,
        logo: logo,
    }),
    computed: {
        menuToggle: {
            get() {
                return this.$store.state.menu.show_menu
            },
            set(newValue) {
                this.$store.commit('SET_MENU', newValue)
            }
        },
    },
    methods: {
        ...mapActions({
            signOutAction: 'auth/signOut'
        }),
        signOut() {
            this.signOutAction().then(() => {
                this.$router.replace({
                    name: 'Home'
                })
            })
        },
        hasHistory () { 
            return window.history.length > 2 
        },
    },
    mounted() {
        if(this.$route.name != 'Dashboard') {
            this.back = true
        }
    },
    watch:{
        $route (to){
            if(to.name == 'Dashboard') {
                this.back = false
            } else {
                this.back = true
            }
        }
    } 
}
</script>

<style lang="sass" scoped>
.top-logo
    position: absolute
    left: 50%
    margin-left: -75px
</style>